import { useDetailPageStore } from '@/page/detail/store';

// 短视频场景下不一定有用到detailPageStore，所以这里需要传入currentSku和pageRawData
export function useSubsidy(_currentSku = undefined, _pageRawData = undefined) {
    let currentSku = useDetailPageStore((s) => s.currentSku);
    currentSku = _currentSku || currentSku;
    let pageRawData = useDetailPageStore((s) => s.pageRawData);
    pageRawData = _pageRawData || pageRawData;
    const priceDiscountDetail = currentSku?.priceDiscountDetail || pageRawData?.priceDiscountDetail || {};
    const hasSubsidy = priceDiscountDetail?.distributorDeductAmount > 0;
    const subsidyItem = pageRawData?.activityList?.find((v) => v?.marketingActivityType === 2005);
    return {
        hasSubsidy: hasSubsidy,
        subsidyItem,
    };
}
